const mapToGalleryImages = (images) => {
    console.log(images);
        return {
            original: images.file ? images.file : images.lg,
            thumbnail: images.file ? images.file : images.sm
        }
}

export default function Image(type,baseFilename,images,file=null){

    const fileLoadTime = new Date().getTime();
    //TODO: ADD GETTER FOR 
    return {
        type: type,
        baseFilename: baseFilename,
        images: type === 'galleryImage' ? mapToGalleryImages(images) : images,
        file: file,
        key: baseFilename.concat(' ',fileLoadTime),
        url: images.file ? images.file : images.sm,
        isResponsive: images.length > 1 ? true : false,
        isLocal: (file !== null ? true : false),
        getImages() {
            if(!this.isLocal){
                console.log('getImages')
                console.log(this.images);
                return this.images;
            }
            else{
                return this.images.file;
            }
        }
    }
    
}




// export default function ImageFile(basename,url,file = null){
    
//     const fileLoadTime = new Date().getTime();

//     return{
//         basename: basename,
//         file: file,
//         filename: file ? file.name : null,
//         url: url,
//         key: basename.concat(' ',fileLoadTime),
//         isLocal: file ? true : false
//     }
    
// }

